import { env as publicEnv } from "$env/dynamic/public";

function defaultGraphqlEndpoint(): string {
  const stack = (publicEnv.PUBLIC_LOCAL_STACK || "compose").toLowerCase();
  if (stack === "k3s" || stack === "k3d") {
    const port = publicEnv.PUBLIC_K3D_HTTP_PORT || "18080";
    return `http://api.localhost:${port}/graphql`;
  }
  return "http://localhost:8000/graphql";
}

export const env = {
  /**
   * Product (H0): Cerebrio — Business Intelligence Centre (cerebrio.cz).
   * Override with PUBLIC_APP_NAME per env.
   * Signed-in tenant Organization.branding.brand takes priority on authenticated
   * chrome (see $lib/stores/branding.svelte.ts). Pre-login uses this only.
   */
  get appName(): string {
    return publicEnv.PUBLIC_APP_NAME || "Cerebrio";
  },
  get appUrl(): string {
    return publicEnv.PUBLIC_APP_URL || "http://localhost:5173";
  },
  /** compose | k3s — which local backend preset is active. */
  get localStack(): string {
    return (publicEnv.PUBLIC_LOCAL_STACK || "compose").toLowerCase();
  },
  get graphqlEndpoint(): string {
    return publicEnv.PUBLIC_GRAPHQL_ENDPOINT || defaultGraphqlEndpoint();
  },
  get graphqlWsEndpoint(): string {
    if (publicEnv.PUBLIC_GRAPHQL_WS_ENDPOINT) return publicEnv.PUBLIC_GRAPHQL_WS_ENDPOINT;
    return this.graphqlEndpoint.replace(/^http/i, "ws");
  },
  get apiBaseUrl(): string {
    return this.graphqlEndpoint.replace(/\/graphql\/?$/, "");
  },
  automationWebhookUrl(token: string): string {
    return `${this.apiBaseUrl}/webhooks/automation/${encodeURIComponent(token)}`;
  },
  get authMock(): boolean {
    return (publicEnv.PUBLIC_AUTH_MOCK ?? "false") === "true";
  },
  /** Public hCaptcha sitekey; empty → forms try GET /public/captcha. */
  get hcaptchaSitekey(): string {
    return (publicEnv.PUBLIC_HCAPTCHA_SITEKEY || "").trim();
  },
};
